import Image from "next/image"
import Link from "next/link"
import type { Article } from "@/components/resources/data/posts.types"
import { BASE_BLOG_PATH } from "@/constants/urls"

type AuthorProps = Article["author"]
export function MiniAuthor({
  slug,
  firstname,
  lastname,
}: Pick<AuthorProps, "slug" | "firstname" | "lastname">) {
  if (!firstname || !lastname) return null

  return (
    <Link
      href={`${BASE_BLOG_PATH}/author/${slug}`}
      rel="author"
      className="text-fg-secondary text-sm font-medium hover:text-fg-default"
    >
      {firstname} {lastname}
    </Link>
  )
}

export function Author({
  image,
  firstname,
  lastname,
  nickname,
  title,
  isGuest,
  socials,
}: AuthorProps) {
  return (
    <>
      <div className="border-t border-neutral-800" />
      <div className="flex flex-col md:flex-row items-center gap-6">
        {image ? (
          <Image
            src={image}
            alt={nickname}
            width={96}
            height={96}
            className="aspect-square shrink rounded-full"
          />
        ) : null}
        <div className="flex flex-col text-left gap-1">
          <h1 className="text-2xl font-medium text-fg-default">
            {firstname} {lastname}
          </h1>
          <p className="text-base font-medium text-fg-secondary">{title}</p>
          {isGuest ? (
            <div className="my-1 py-0.5 px-2 bg-neutral-100 text-neutral-900 font-medium rounded-md self-start">
              <span>Guest Contributor</span>
            </div>
          ) : null}
          {socials.length ? (
            <div className="flex gap-4">
              {socials.map(({ platform, url }) => (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="me noopener noreferrer"
                  className="text-fg-default underline underline-offset-2 hover:opacity-80"
                >
                  {platform}
                </a>
              ))}
            </div>
          ) : null}
        </div>
      </div>
      <div className="border-t border-neutral-800" />
    </>
  )
}
